import { render, staticRenderFns } from "./topRankingLock.vue?vue&type=template&id=491de0a7&"
import script from "./topRankingLock.vue?vue&type=script&lang=js&"
export * from "./topRankingLock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports